module.exports = __webpack_public_path__ + "static/media/claim_handling_diagram.c027ec6f.png";